module.exports = __webpack_public_path__ + "static/media/visa.bf0fdffa.svg";